export enum SuggestionMode {
  SEARCH = 'search',
  LABELS = 'labels'
}
